import { CssBaseline } from '@material-ui/core';

import {
  AppTheme,
  ExtensionDefinition,
  ThemeBlueprint,
  createExtension,
} from '@backstage/frontend-plugin-api';

import { IconMix, IconMoon } from '@spotify/confidence-core-react';

import {
  EncoreDarkThemeProvider,
  EncoreLightThemeProvider,
} from './EncoreThemeProvider';
import {
  MuiBuiDarkThemeProvider,
  MuiBuiLightThemeProvider,
} from './MuiBuiThemeProvider';

const buiConfigs: AppTheme[] = [
  {
    id: 'mui-bui-dark',
    title: 'Dark theme',
    variant: 'dark',
    icon: <IconMoon />,
    Provider: ({ children }) => (
      <MuiBuiDarkThemeProvider>
        <CssBaseline>{children}</CssBaseline>
      </MuiBuiDarkThemeProvider>
    ),
  },
  {
    id: 'mui-bui-light',
    title: 'Light theme',
    variant: 'light',
    icon: <IconMix />,
    Provider: ({ children }) => (
      <MuiBuiLightThemeProvider>
        <CssBaseline>{children}</CssBaseline>
      </MuiBuiLightThemeProvider>
    ),
  },
];

const themeConfigs: AppTheme[] = [
  {
    id: 'encore-dark',
    title: 'Encore Dark',
    variant: 'dark',
    icon: <IconMoon />,
    Provider: ({ children }) => (
      <EncoreDarkThemeProvider>
        <CssBaseline>{children}</CssBaseline>
      </EncoreDarkThemeProvider>
    ),
  },
  {
    id: 'encore-light',
    title: 'Encore Light',
    variant: 'light',
    icon: <IconMix />,
    Provider: ({ children }) => (
      <EncoreLightThemeProvider>
        <CssBaseline>{children}</CssBaseline>
      </EncoreLightThemeProvider>
    ),
  },
  ...buiConfigs,
];

const extensions: ExtensionDefinition[] = [];

// disabling the default themes from Backstage
for (const id of ['light', 'dark']) {
  if (!themeConfigs.some(theme => theme.id === id)) {
    extensions.push(
      createExtension({
        kind: 'theme',
        name: id,
        attachTo: { id: 'api:app/app-theme', input: 'themes' },
        disabled: true,
        output: [],
        factory: () => [],
      }),
    );
  }
}

extensions.push(
  ...themeConfigs.map(theme =>
    ThemeBlueprint.make({
      name: theme.id,
      params: { theme },
    }),
  ),
);

export const AppThemes = extensions;
